module.exports = __webpack_public_path__ + "img/115.823931e4.jpg";